import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const KEY = "moon_cart_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const keyOf = (i) => `${i.item_id}::${i.variant || ""}`;

  const add = (item, variant = null) => {
    setItems((prev) => {
      const unit_price = Number(item.price) + Number(variant?.price_delta || 0);
      const vname = variant?.name || null;
      const k = `${item.item_id}::${vname || ""}`;
      const idx = prev.findIndex((p) => keyOf(p) === k);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + 1 };
        return next;
      }
      return [...prev, {
        item_id: item.item_id, name: item.name, image_url: item.image_url,
        variant: vname, unit_price, quantity: 1,
      }];
    });
    setOpen(true);
  };

  const updateQty = (k, delta) => {
    setItems((prev) => prev.flatMap((p) => {
      if (keyOf(p) !== k) return [p];
      const q = p.quantity + delta;
      if (q <= 0) return [];
      return [{ ...p, quantity: q }];
    }));
  };

  const remove = (k) => setItems((prev) => prev.filter((p) => keyOf(p) !== k));
  const clear = () => setItems([]);

  const subtotal = useMemo(() => items.reduce((s, i) => s + i.unit_price * i.quantity, 0), [items]);
  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);

  return (
    <CartContext.Provider value={{ items, add, updateQty, remove, clear, subtotal, count, open, setOpen, keyOf }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
